"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReactRouterLink = exports.StyledStormLink = exports.CardFooter = exports.CardBody = exports.ContentContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
var react_router_dom_1 = require("react-router-dom");
exports.ContentContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin: ", ";\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
});
exports.CardBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.medium;
});
exports.CardFooter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n  padding-bottom: 0;\n"], ["\n  padding: ", ";\n  padding-bottom: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.base;
});
exports.StyledStormLink = (0, styled_components_1.default)(storm_ui_1.Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
exports.StyledReactRouterLink = (0, styled_components_1.default)(react_router_dom_1.Link)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
